import { Injectable } from '@angular/core';
import { ApiHttpClient } from '../modules/tcm-core.module';
import { NonSerializedItemAdjustRequest, NonSerializedItemReturnRequest } from '../models/non-serialized-items';

@Injectable({
  providedIn: 'root'
})
export class NonSerializedDataService {
  constructor(private readonly httpClient: ApiHttpClient) {
  }

  checkProductStyleInClinicExists(productStyleId: number, clinicId: string, id: number, timeout: Promise<any>): Promise<boolean> {
    const request = { productStyleId: productStyleId, clinicId: clinicId, id: id };
    return this.httpClient.getJsonAsync<boolean>('nonserializeditems/checkProductStyleInClinicExists', request, timeout, false);
  }

  nonSerializedItemAdjustAsync(request: NonSerializedItemAdjustRequest, timeout: Promise<any>) {
    return this.httpClient.postJsonAsync<boolean>('nonserializeditems/nonSerializedItemAdjust', request, timeout);
  }

  nonSerializedItemReturnAsync(request: NonSerializedItemReturnRequest, timeout: Promise<any>) {
    return this.httpClient.postJsonAsync<boolean>('nonserializeditems/nonSerializedItemReturn', request, timeout);
  }
}
